"use client";

import { GTMEvent } from ".constants/gtmEvents";
import { PORTALS } from ".constants/portals";
import { usePortalContext } from "@cloai/uikit";
import { FC, HTMLAttributes, MouseEvent, useEffect, useState } from "react";

import { useGTMContext } from "@/providers";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}
type PwaButtonProps = HTMLAttributes<HTMLDivElement> & {
  portalEvent: GTMEvent;
  promptEvent: GTMEvent;
  setIsVisible(prev: boolean): void;
};

const WRAPPER_ID = "pwaButtonWrapper";

export const PwaButton: FC<PwaButtonProps> = ({
  children,
  portalEvent,
  promptEvent,
  setIsVisible,
  ...props
}) => {
  const { sendGTM } = useGTMContext();
  const { openPortal } = usePortalContext();

  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);

  const promptAppInstall = async (e: MouseEvent<HTMLDivElement>) => {
    const el = e.target as HTMLElement;

    // если юзер кликает по пустой области внутри div, а не на конкретно children, то ничего не делаем
    if (el.id === WRAPPER_ID) {
      return;
    }

    if (!deferredPrompt) {
      sendGTM({ event: portalEvent });
      openPortal(PORTALS.PWA);
      return;
    }

    sendGTM({ event: promptEvent });
    await deferredPrompt.prompt();
    await deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("user accepted A2HS prompt");
        setIsVisible(false);
      } else {
        console.log("user dismissed A2HS prompt");
      }
    });
    setDeferredPrompt(null);
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  return (
    <div id={WRAPPER_ID} onClick={promptAppInstall} {...props}>
      {children}
    </div>
  );
};
